/** Archive privacy model — private placeholders vs claimed/shared profiles. */

export const IDENTITY_STATUS = {
  PRIVATE_PLACEHOLDER: 'private_placeholder',
  SHARED_PROFILE: 'shared_profile',
  CLAIMED: 'claimed',
};

export const PRIVATE_ARCHIVE_HEADLINE = 'Added to your private archive';

export const PRIVATE_ARCHIVE_POINTS = [
  'This profile lives in your archive until they choose to join.',
  'They can be invited later — nothing is shared without consent.',
  'If they sign up, their profile can be claimed or merged.',
];

export function isPrivatePlaceholder(person) {
  return person?.identity_status === IDENTITY_STATUS.PRIVATE_PLACEHOLDER;
}

export function privateArchiveBadgeLabel() {
  return 'Private archive profile';
}

export function privateArchiveHint(name) {
  const who = name ? name.split(' ')[0] : 'They';
  return `${who} has not joined or claimed this profile yet. You can preserve memories here and invite them when the time is right.`;
}
